<div v-show="!loading" class="app-layout">
  <IziGrid class="content">
    <slot />
  </IziGrid>
  <Toolbar class="toolbar p-card">
    <template #left>
      <router-link :to="{ name: 'hall' }">
        <Logo />
      </router-link>
      <EnterPin />
      <slot name="leftHeader"></slot>
    </template>
    <template #right>
      <slot name="rightHeader"></slot>
      <IziButton class="open-sidebar-right" matIcon="view_headline" buttonType="primary" theme="text" @click="visibleLeft = true" />
      <router-link class="btn-hall" :to="{ name: 'hall' }">
        <Button class="button-hall"> <img src="../../../assets/izi_icon.png" style="width: 30px; height: 30px;" /> HALL</Button>
      </router-link>
      <ProfileHeader />
      <IziButton class="open-sidebar-right" matIcon="military_tech" buttonType="primary" theme="text" @click="visibleRight = true" />
    </template>
  </Toolbar>
</div>
<Sidebar v-model:visible="visibleLeft">
  <component :is="'LeftHall'" class="component-sidebar-left" />
</Sidebar>
<Sidebar v-model:visible="visibleRight" position="right" class="sidebar-right">
  <component :is="'RightHall'" class="component-sidebar-right" />
</Sidebar>
<Galleria :value="galleria.value" :responsiveOptions="responsiveOptions" :numVisible="8"
  containerStyle="max-width: 850px" :circular="true" :fullScreen="true" :showItemNavigators="true"
  :showThumbnails="false" v-model:visible="galleria.visible">
  <template #item="slotProps">
    <img :src="slotProps.item.src" :alt="slotProps.item.alt" style="width: 100%; display: block;" />
  </template>
  <template #thumbnail="slotProps">
    <img :src="slotProps.item.src" :alt="slotProps.item.alt" style="display: block; width: 100%;" />
  </template>
</Galleria>
<div class="loading-screen" v-show="loading">
  <ProgressSpinner class="center" />
</div>